export var source = "query Brand($slug: String!) {\n  brandBySlug(slug: $slug) {\n    name\n    logo\n    description,\n    products {\n      ...ProductBase\n    }\n  }\n}";
import { source as fragment1 } from "../../../helpers/fragments/productBase.graphql";
var combined = source  + "\n" + fragment1;
export default combined;